import { z } from 'zod';
import { ptBR } from 'zod/locales';
/**
 * Mensagens do Zod na voz da fábrica, as mesmas na web (formulários) e na
 * API (validação de entrada do tRPC). Os schemas compartilhados já trazem
 * mensagem própria nos casos importantes ("Informe o nome"); este mapa cobre
 * o que escapa — campo vazio, número onde se esperava número, data inválida —
 * para nunca aparecer "Too small: expected string to have >=1 characters".
 * O que não estiver aqui cai na tradução oficial `pt-BR` do Zod.
 */
const vazio = (v) => v === undefined || v === null || v === '';
const formatar = (n) => n.toLocaleString('pt-BR');
export const mensagensZod = (issue) => {
    switch (issue.code) {
        case 'invalid_type': {
            if (vazio(issue.input))
                return 'Preencha este campo';
            if (issue.expected === 'number' || issue.expected === 'int')
                return 'Informe um número';
            if (issue.expected === 'date')
                return 'Informe uma data válida';
            if (issue.expected === 'boolean')
                return 'Marque sim ou não';
            return 'Valor inválido';
        }
        case 'too_small': {
            const min = Number(issue.minimum);
            if (issue.origin === 'string') {
                return min <= 1 ? 'Preencha este campo' : `Use ao menos ${min} caracteres`;
            }
            if (issue.origin === 'array') {
                return min <= 1 ? 'Informe ao menos um item' : `Informe ao menos ${min} itens`;
            }
            if (issue.origin === 'number' || issue.origin === 'int') {
                if (min === 0 && !issue.inclusive)
                    return 'Deve ser maior que zero';
                if (min === 0)
                    return 'Não pode ser negativo';
                return issue.inclusive ? `Mínimo: ${formatar(min)}` : `Deve ser maior que ${formatar(min)}`;
            }
            return undefined;
        }
        case 'too_big': {
            const max = Number(issue.maximum);
            if (issue.origin === 'string')
                return `Máximo de ${max} caracteres`;
            if (issue.origin === 'array')
                return `No máximo ${max} itens`;
            if (issue.origin === 'number' || issue.origin === 'int') {
                return issue.inclusive ? `Máximo: ${formatar(max)}` : `Deve ser menor que ${formatar(max)}`;
            }
            return undefined;
        }
        case 'invalid_format': {
            if (issue.format === 'email')
                return 'E-mail inválido';
            if (issue.format === 'regex')
                return 'Formato inválido';
            if (issue.format === 'uuid')
                return 'Identificador inválido';
            return undefined;
        }
        case 'invalid_value':
            return 'Escolha uma opção válida';
        case 'not_multiple_of':
            return `Use múltiplos de ${formatar(issue.divisor)}`;
        case 'unrecognized_keys':
            return 'Há campos que o sistema não reconhece';
        case 'invalid_union':
        case 'invalid_key':
        case 'invalid_element':
        case 'custom':
            return undefined;
    }
};
/** Chame uma vez, antes de qualquer validação (main.tsx da web, app.ts da API, setup dos testes). */
export function instalarMensagensZod() {
    z.config({ ...ptBR(), customError: mensagensZod });
}
//# sourceMappingURL=mensagens-pt-br.js.map